<template>
  <v-app>
    <component :is="layoutComponent" />
  </v-app>
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import Sidebar from "@/components/layout/Sidebar.vue";
import Login from "@/views/Login.vue";

const route = useRoute();

const layoutComponent = computed(() => {
  // Si estás en /login, muestra solo Login.vue
  if (route.path === "/login") return Login;
  // Para cualquier otra ruta, usa el layout principal
  return Sidebar;
});
</script>

<style>
.app-container {
  display: flex;
  width: 100%;
}

.main-content {
  flex-grow: 1;
}

html {
  overflow-y: auto;
}

body::-webkit-scrollbar {
  display: none;
}
</style>